import { UserOrgWithOrgDto } from '@gap/backend/app-services/user-org/models/UserOrgWithOrgDto'

const sortByLabel = (orgA: UserOrgWithOrgDto, orgB: UserOrgWithOrgDto) => orgA.name.localeCompare(orgB.name)

/**
 * Lists the orgs shown in the org switcher, grouped gap, advisor then client and sorted by name.
 * @param orgs Every org the user belongs to.
 * @param currentOrgId The org the user is currently viewing.
 * @returns The switcher entries, with guest client orgs kept only while current.
 */
export function switcherOrgs(orgs: UserOrgWithOrgDto[], currentOrgId: string | undefined): UserOrgWithOrgDto[] {
   const sortedOrgs = orgs.slice().sort(sortByLabel)
   const gapOrgs = sortedOrgs.filter(org => org.orgType === 'gap')
   const advisorOrgs = sortedOrgs.filter(org => org.orgType === 'advisor')
   const clientOrgs = sortedOrgs.filter(org => {
      if (org.orgType !== 'client') return false
      const isCurrent = org.id === currentOrgId
      const isGuest = org.roleName.toLowerCase() === 'guest'
      return isCurrent || !isGuest
   })

   return [...gapOrgs, ...advisorOrgs, ...clientOrgs]
}
